'use strict';

import { Dropdown } from './dropdown.js';

export class DropdownMyadssort extends Dropdown {
	constructor(component_key) {
		super(component_key);
	}
	add_events() {
		this.$selected.on('click', `.js-${this.id}_option`,
			this.selected_click_handler.bind(this)
		);
		this.$list.on('click', `.js-${this.id}_option`,
			this.option_click_handler.bind(this)
		);
		jQuery(`.js-${this.id}`).on('blur', this.close_all.bind(this));
	}
	option_click_handler(event) {
		const $element = jQuery(event.currentTarget);
		if ($element.is(':first-child')) {
			return;
		}
		super.option_click_handler(event);
		this.$options = this.$list.find(`.js-${this.id}_option`);
		this.$options.first().remove();
		$element.clone().prependTo(this.$list);
		this.$options = this.$list.find(`.js-${this.id}_option`);
		yalwa.basics.set_get({sb: $element.data('value') ? $element.data('value') : null}, true, true);
	}
}
